module.exports = __webpack_public_path__ + "img/34.2c7faa53.png";